var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"address-picker"},[_c('PickerButton',{attrs:{"placeholder":_vm.placeholder,"value":_vm.address},nativeOn:{"click":function($event){return _vm.onClickButton.apply(null, arguments)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }